import React from 'react';
import { Modal, Form, Input, Typography, Button, Space } from 'antd';
import { FolderOutlined, RightOutlined } from '@ant-design/icons';
import { PostFolder } from '../../../../../../../types/postFolders';
import './style.css';

const { Text } = Typography;

interface CreateFolderModalProps {
  open: boolean;
  spaceName: string;
  parentFolder: PostFolder | null;
  onCancel: () => void;
  onSubmit: (values: { name: string }) => Promise<void>;
}

const CreateFolderModal: React.FC<CreateFolderModalProps> = ({
  open,
  parentFolder,
  spaceName,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = React.useState(false);

  const handleSubmit = async (values: { name: string }) => {
    try {
      setSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      // Form validation error, no need to handle
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={
        <div className="modal-title">
          <div className="title-text">New Folder</div>
          <div className="folder-path">
            <FolderOutlined /> {spaceName}
            {parentFolder && (
              <>
                <RightOutlined />
                <Text strong>{parentFolder.name}</Text>
              </>
            )}
          </div>
        </div>
      }
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      destroyOnClose
      footer={null}
      width={480}
      className="create-folder-modal"
      centered
      maskClosable
    >
      <Form
        form={form}
        layout="vertical"
        preserve={false}
        onFinish={async (values) => {
          await handleSubmit(values);
          form.resetFields();
        }}
      >
        <Form.Item
          name="name"
          label="Folder name"
          rules={[
            { required: true, message: 'Please enter folder name' },
            { pattern: /^[a-zA-Z0-9\s_-]+$/, message: 'Only letters, numbers, spaces, hyphens and underscores allowed' },
            { max: 50, message: 'Folder name cannot be longer than 50 characters' }
          ]}
        >
          <Input 
            placeholder="Enter folder name"
            autoFocus
            size="large"
          />
        </Form.Item>
        <Form.Item className="modal-footer">
          <Space>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={submitting}>
              Create Folder
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateFolderModal; 